import StorageManager from './StorageManager'
import { shuffleArray } from '../utils/utils'
import { analytics } from './Analytics/Analytics'
import { ATTRIBUTION_SURVEY_KEY } from '../pages/EmailCapturePage/EmailCapturePage.consts'
import UserManager from './UserManager'
import { ServerSideAnalyticsPlatform } from './Analytics/ServerSideAnalytics'
import { mixtilesAxios } from '../utils/ApiUtils'
import { getAmplitudeDeviceId } from './Analytics/platforms/amplitude'
import { isClient } from 'utils/runtimeUtils'

export const channelsToTranslatedChannels = {
  Pinterest: 'new_email_capture.attribution.channels.pinterest',
  Email: 'new_email_capture.attribution.channels.email',
  TV: 'new_email_capture.attribution.channels.tv',
  Facebook: 'new_email_capture.attribution.channels.facebook',
  Snapchat: 'new_email_capture.attribution.channels.snapchat',
  Flyer: 'new_email_capture.attribution.channels.flyer',
  Shorts: 'new_email_capture.attribution.channels.shorts',
  Youtube: 'new_email_capture.attribution.channels.youtube',
  Google: 'new_email_capture.attribution.channels.google',
  Game: 'new_email_capture.attribution.channels.game',
  Instagram: 'new_email_capture.attribution.channels.instagram',
  Friend: 'new_email_capture.attribution.channels.friend',
  Podcast: 'new_email_capture.attribution.channels.podcast',
  Airport: 'new_email_capture.attribution.channels.airport',
  StaceySolomon: 'new_email_capture.attribution.channels.stacey_solomon',
  RebeccaJudd: 'new_email_capture.attribution.channels.rebecca_judd',
  TamminSursok: 'new_email_capture.attribution.channels.tammin_sursok',
  TiaMowry: 'new_email_capture.attribution.channels.tia_mowry',
  Tiktok: 'new_email_capture.attribution.channels.tiktok',
  Twitter: 'new_email_capture.attribution.channels.twitter',
  Other: 'new_email_capture.attribution.channels.other',
}

export const ATTRIBUTION_SOURCE = {
  onboarding: 'Onboarding',
  postPurchase: 'Post Purchase',
  artOnboarding: 'Art Onboarding',
}

class AttributionSurveyManager {
  constructor() {
    this.ATTRIBUTION_CHANNELS = this.initAttributionChannelsList()
  }

  getAttributionChannelsList = () => {
    return this.ATTRIBUTION_CHANNELS
  }

  initAttributionChannelsList = () => {
    let ATTRIBUTION_CHANNELS = [
      'Pinterest',
      'Email',
      'TV',
      'Facebook',
      'Game',
      'Youtube',
      'Google',
      'Instagram',
      'Friend',
      'Airport',
      'Tiktok',
    ]

    if (isClient() && !StorageManager.get('Shuffled Attribution Array')) {
      shuffleArray(ATTRIBUTION_CHANNELS)
      StorageManager.set('Shuffled Attribution Array', true)
    }

    if (!ATTRIBUTION_CHANNELS.includes('Other')) {
      ATTRIBUTION_CHANNELS = ATTRIBUTION_CHANNELS.concat('Other') // Keep Other to be always the last option
    }

    return ATTRIBUTION_CHANNELS
  }

  trackAttributionSurveyAnalytics = ({ channelName, subChannel, source }) => {
    if (channelName) {
      const eventProperties = {
        Answer: channelName,
        'Is New Email': UserManager.isNewEmail(),
        'Sub Attribution': subChannel,
        Source: source,
      }

      analytics.track('Attribution Survey Answered', eventProperties, {
        serverSideAnalyticsPlatforms: [ServerSideAnalyticsPlatform.Facebook],
      })
      analytics.setUserProperties({
        'Attribution Survey': channelName,
        'Sub Attribution Survey': subChannel,
        'Attribution Survey Source': source,
      })
      StorageManager.set(ATTRIBUTION_SURVEY_KEY, channelName)

      if (
        source !== ATTRIBUTION_SOURCE.artOnboarding &&
        channelName !== 'Skip'
      ) {
        const amplitudeDeviceId = getAmplitudeDeviceId()
        mixtilesAxios.post('/v1/user/userCapturedData', {
          attributionSurveyAnswer: channelName,
          amplitudeDeviceId,
        })
      }
    }
  }

  didAnswerSurvey = () => {
    const attributionResult = StorageManager.get(ATTRIBUTION_SURVEY_KEY)
    return !!attributionResult && attributionResult !== 'Skip'
  }
}

export const attributionSurveyManager = new AttributionSurveyManager()
